module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/summer_expedition_bg.42528385.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/summer_expedition_bg.jpg
// module id = 1329
// module chunks = 16